import React, { Component } from 'react'
import PropTypes from 'prop-types'

class AppWrapper extends Component {
  static propTypes = {
    children: PropTypes.node
  }

  render () {
    return (
      <div>
        {this.props.children}
        <div id='customModalRoot' />
      </div>
    )
  }
}

export default AppWrapper
